import Modal, { ModalFooter } from '@amzn/meridian/modal';

import Button from '@amzn/meridian/button';
import React from 'react';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';

const GenericDialog = ({
  isOpen,
  setIsOpen,
  isConfirmDisabled,
  text,
  onConfirm,
  title,
  actionButtonCaption,
  cancelButtonCaption,
}) => {
  const confirmModal = () => {
    setIsOpen(false);
    onConfirm();
  };

  const cancelModal = () => {
    setIsOpen(false);
  };

  return (
    <Modal title={title} open={isOpen} scrollContainer="viewport" describedById="modal-description">
      <Row className="m-3">
        <Text>{text}</Text>
      </Row>
      <ModalFooter>
        <Row alignmentHorizontal="right" widths="fit">
          <Button type="secondary" size="small" onClick={cancelModal}>
            {cancelButtonCaption}
          </Button>
          <Button type="primary" size="small" onClick={confirmModal} disabled={isConfirmDisabled}>
            {actionButtonCaption}
          </Button>
        </Row>
      </ModalFooter>
    </Modal>
  );
};

export default GenericDialog;
